import React from 'react'
import { Container } from '@components/index'
import CreatePassword from '@pages/auth/CreatePassword'
import {
    CreateRealEstate,
    EditPassword,
    Error404,
    ForgotPassword,
    Highlights,
    Home,
    Login,
    RealEstates,
    RecoveryCode,
    ResetPassword,
    UpdateRealEstate,
    HighlightForm,
    CreateUpdateUsers,
    Users,
    FormTableSales,
    ListTableSales,
    RealtorsForm,
    ClientsForm,
    Contacts,
    Maintenances,
    Apartments,
    FormApartments,
    ConfigurationPage
} from '@pages/index'
import CustomRoute from '@routes/CustomRoute'
import { BrowserRouter, Route, Routes as Router } from 'react-router-dom'
import { USER_ROLE } from '@interfaces/userManagement/enums/userRole'

export default function Routes(): React.ReactElement {
    return (
        <BrowserRouter>
            <Router>
                <Route
                    path="/login"
                    element={
                        <CustomRoute public>
                            <Login />
                        </CustomRoute>
                    }
                />
                <Route
                    path="/forgot-pass"
                    element={
                        <CustomRoute public>
                            <ForgotPassword />
                        </CustomRoute>
                    }
                />
                <Route
                    path="/recovery-code"
                    element={
                        <CustomRoute public>
                            <RecoveryCode />
                        </CustomRoute>
                    }
                />
                <Route
                    path="/reset-password"
                    element={
                        <CustomRoute public>
                            <ResetPassword />
                        </CustomRoute>
                    }
                />
                <Route
                    path="/cadastrar-senha/:id"
                    element={
                        <CustomRoute public>
                            <CreatePassword />
                        </CustomRoute>
                    }
                />
                <Route
                    path="/"
                    element={
                        <CustomRoute private>
                            <Container>
                                <Home />
                            </Container>
                        </CustomRoute>
                    }
                />
                <Route
                    path="/edit-password"
                    element={
                        <CustomRoute private>
                            <Container>
                                <EditPassword />
                            </Container>
                        </CustomRoute>
                    }
                />
                <Route
                    path="/imoveis"
                    element={
                        <CustomRoute private>
                            <Container>
                                <RealEstates />
                            </Container>
                        </CustomRoute>
                    }
                />
                <Route
                    path="/imoveis/cadastrar"
                    element={
                        <CustomRoute private>
                            <Container>
                                <CreateRealEstate />
                            </Container>
                        </CustomRoute>
                    }
                />
                <Route
                    path="/imoveis/:id/editar"
                    element={
                        <CustomRoute private>
                            <Container>
                                <UpdateRealEstate />
                            </Container>
                        </CustomRoute>
                    }
                />
                <Route
                    path="/configuracoes"
                    element={
                        <CustomRoute private>
                            <Container>
                                <ConfigurationPage/>
                            </Container>
                        </CustomRoute>
                    }
                />
                <Route
                    path="/destaques"
                    element={
                        <CustomRoute private>
                            <Container>
                                <Highlights />
                            </Container>
                        </CustomRoute>
                    }
                />
                <Route
                    path="/destaques/novo"
                    element={
                        <CustomRoute private>
                            <Container>
                                <HighlightForm />
                            </Container>
                        </CustomRoute>
                    }
                />
                <Route
                    path="/destaques/:id/editar"
                    element={
                        <CustomRoute private>
                            <Container>
                                <HighlightForm />
                            </Container>
                        </CustomRoute>
                    }
                />
                <Route
                    path='/user-management/create-user'
                    element={
                        <CustomRoute private>
                            <Container>
                                <CreateUpdateUsers />
                            </Container>
                        </CustomRoute>
                    }
                />
                <Route
                    path='/user-management/update-user/:id'
                    element={
                        <CustomRoute private>
                            <Container>
                                <CreateUpdateUsers />
                            </Container>
                        </CustomRoute>
                    }
                />
                <Route
                    path="/manutencoes"
                    element={
                        <CustomRoute private>
                            <Container>
                                <Maintenances />
                            </Container>
                        </CustomRoute>
                    }
                />
                {/* <Route
                    path='/site/galeria-tv'
                    element={
                        <CustomRoute private>
                            <Container>
                                <GalleryTV />
                            </Container>
                        </CustomRoute>
                    }
                /> */}
                <Route
                    path='/tabela-de-vendas'
                    element={
                        <CustomRoute private>
                            <Container>
                                <ListTableSales />
                            </Container>
                        </CustomRoute>
                    }
                />
                <Route
                    path='/tabela-de-vendas/cadastrar'
                    element={
                        <CustomRoute private>
                            <Container>
                                <FormTableSales />
                            </Container>
                        </CustomRoute>
                    }
                />
                <Route
                    path='/tabela-de-vendas/editar/:id'
                    element={
                        <CustomRoute private>
                            <Container>
                                <FormTableSales />
                            </Container>
                        </CustomRoute>
                    }
                />
                <Route
                    path='/administradores'
                    element={
                        <CustomRoute private>
                            <Container>
                                <Users role={USER_ROLE.ADMIN} key={USER_ROLE.ADMIN} />
                            </Container>
                        </CustomRoute>
                    }
                />

                <Route
                    path='/administradores/novo'
                    element={
                        <CustomRoute private>
                            <Container>
                                <CreateUpdateUsers />
                            </Container>
                        </CustomRoute>
                    }
                />

                <Route
                    path='/administradores/:id'
                    element={
                        <CustomRoute private>
                            <Container>
                                <CreateUpdateUsers />
                            </Container>
                        </CustomRoute>
                    }
                />

                <Route
                    path='/corretores'
                    element={
                        <CustomRoute private>
                            <Container>
                                <Users role={USER_ROLE.REALTOR} key={USER_ROLE.REALTOR} />
                            </Container>
                        </CustomRoute>
                    }
                />

                <Route
                    path='/corretores/:id'
                    element={
                        <CustomRoute private>
                            <Container>
                                <RealtorsForm />
                            </Container>
                        </CustomRoute>
                    }
                />

                <Route
                    path='/clientes'
                    element={
                        <CustomRoute private>
                            <Container>
                                <Users role={USER_ROLE.CLIENT} key={USER_ROLE.CLIENT} />
                            </Container>
                        </CustomRoute>
                    }
                />
                <Route
                    path='/clientes/:id'
                    element={
                        <CustomRoute private>
                            <Container>
                                <ClientsForm />
                            </Container>
                        </CustomRoute>
                    }
                />

                <Route
                    path="/contatos"
                    element={
                        <CustomRoute private>
                            <Container>
                                <Contacts />
                            </Container>
                        </CustomRoute>
                    }
                />

                <Route
                    path="/apartamentos"
                    element={
                        <CustomRoute private>
                            <Container>
                                <Apartments />
                            </Container>
                        </CustomRoute>
                    }
                />

                <Route
                    path="/apartamentos/cadastrar"
                    element={
                        <CustomRoute private>
                            <Container>
                                <FormApartments />
                            </Container>
                        </CustomRoute>
                    }
                />

                <Route
                    path="/apartamentos/editar/:id"
                    element={
                        <CustomRoute private>
                            <Container>
                                <FormApartments />
                            </Container>
                        </CustomRoute>
                    }
                />
                <Route path="*" element={<Error404 />} />
            </Router >
        </BrowserRouter >
    )
}
